import find from "lodash/find";
import { AvailabilityMode } from "PFTypes/booking";
import { Option } from "PFTypes/options";
import { useTranslation } from "react-i18next";

export const useModeOptions = (
  mode: Omit<AvailabilityMode, AvailabilityMode.TimeRule>,
  allowedModes: AvailabilityMode[]
) => {
  const { t } = useTranslation();

  const availabilityModes: Option<AvailabilityMode>[] = [
    {
      id: AvailabilityMode.Within,
      value: AvailabilityMode.Within,
      original: AvailabilityMode.Within,
      displayElement: t("availabilityRequirement.withinPeriod")
    },
    {
      id: AvailabilityMode.PerWeek,
      value: AvailabilityMode.PerWeek,
      original: AvailabilityMode.PerWeek,
      displayElement: t("availabilityRequirement.perWeek")
    },
    {
      id: AvailabilityMode.PerMonth,
      value: AvailabilityMode.PerMonth,
      original: AvailabilityMode.PerMonth,
      displayElement: t("availabilityRequirement.perMonth")
    }
  ].filter(({ id }) => allowedModes.includes(id));

  const currentMode = find(availabilityModes, ["id", mode]) || availabilityModes[0];

  if (!currentMode) {
    throw new Error("Mode not supported");
  }

  return { availabilityModes };
};
